import React from 'react'
import { SVGIconProps } from '../types'
const SvgViewList = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M4 14h4v-4H4zm0 5h4v-4H4zM4 9h4V5H4zm5 5h12v-4H9zm0 5h12v-4H9zM9 5v4h12V5z" />
  </svg>
)
export default SvgViewList
